import React, { useState, useEffect} from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import colours from './Colours';
import Icon from './Icons/Icon';
import { LoadingIcon } from '../Loading_Icon';
import { Heading6 } from './Text';

const PopupModal = (props) => {

    const [loaded, setLoaded] = useState(false);

    useEffect(()=> {
        setLoaded(true);
    })

    return (
        <div className="reveal" id="retirevehicle-overlay" style={{display: "block", top: '0px', borderRadius: 16, overflow: 'hidden'}}>
            <div className = "card no-margin" style={{borderRadius: 16}}>
                { loaded ?
                    <div className = "card-section">
                        <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                            {props.headerText ? <div style={{display: 'flex', flex:1,  alignItems: 'center', justifyContent: 'center'}}>
                                <Heading6 style={props.headerTextStyle}>{props.headerText}</Heading6>
                            </div> : null}
                            <button className="close-button" onClick={props.close ? props.close : () => {}} type='button'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        {props.headerIcon ? <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 32}}>
                            <Icon name={props.headerIcon} style={props.headerIconStyle} size={64}/>
                        </div> : null}
                        <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', marginTop: 32, marginLeft: 16, marginRight: 16, textAlign: 'center'}}>
                            {props.content}
                        </div>
                    </div>
                :   <div>
                        <LoadingIcon/>
                    </div>
                }
            </div>
        </div>
    )
}

PopupModal.defaultProps = {
    headerIcon: '',
    headerIconStyle: null,
    headerText: '',
    headerTextStyle: null,
    close: null,
    content: null,
};

PopupModal.propTypes = {
    headerIcon: PropTypes.string,
    headerIconStyle: PropTypes.object,
    headerText: PropTypes.string | PropTypes.node,
    headerTextStyle: PropTypes.object,
    close: PropTypes.func.isRequired,
    content: PropTypes.element.isRequired
}

export default PopupModal;